import { PolygonOptions } from '@realpage-da/ng-map';
import { ColorConstants } from '~/shared/utils/color-constants';

export const MARKET_BOUNDARY_STYLE: PolygonOptions = {
  color: ColorConstants.CHARCOAL_LIGHT,
  lineWidth: 3,
  opacity: 0,
}

export const SUBMARKET_BOUNDARY_STYLE: PolygonOptions = {
  color: ColorConstants.AQUA,
  opacity: 0,
  lineWidth: 3
}





// WEBPACK FOOTER //
// ./src/app/main/constants/boundary-styles.ts